import { frontendURL } from '../../../helper/URLHelper';
import CallsIndex from './CallsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calls'),
    name: 'relay_voice_calls',
    component: CallsIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
